import React, { useMemo, useCallback } from 'react';
import _get from 'lodash/get';

import { Tracking } from 'bdvp-tracking';

import {
    Content,
    Container,
    AccordionItem,
} from './FilterWrapper.styles';
import { getSubHeaderValue } from './utils';
import Filter from '../../Filter';
import {
    normalizeFields,
    filterOnChange,
    shouldNotReRender,
} from '../utils';

const FilterWrapper = (props) => {

    const {
        fieldsData,
        filterConfig,
        activeFilters,
        addSelectedFilter,
        removeSelectedFilter,
        contentId,
        ...restProps
    } = props;

    const isCollapsibleFilter = useMemo(() => _get(filterConfig, 'collapsible.enabled'), [filterConfig]);
    const initOpen = useMemo(() => _get(filterConfig, 'collapsible.initOpen'), [filterConfig]);
    const componentConfig = useMemo(() => _get(filterConfig, 'componentConfig', {}), [filterConfig]);

    const fields = useMemo(() => normalizeFields(filterConfig, fieldsData, activeFilters), [
        filterConfig,
        fieldsData,
        activeFilters,
    ]);

    const subHeaderText = useMemo(() => {

        const values = fields.map(field => getSubHeaderValue(field.selected));
        return values.join(', ');

    },[fields]);

    const filterOnChangeHandler = useCallback((data, field) => {

        return filterOnChange(data, field, addSelectedFilter, removeSelectedFilter);

    }, [
        addSelectedFilter,
        removeSelectedFilter,
    ]);

    return (
        <Container>
            <AccordionItem
                headline={filterConfig.filterName}
                showIcon={isCollapsibleFilter}
                subHeaderText={subHeaderText}
                contentId={contentId}
                initOpen={initOpen}
                isOpen={!isCollapsibleFilter ? true : undefined}
                handlers={
                    {
                        onOpen: (event) => {

                            const target = event.currentTarget;
                            const dataName = target.getAttribute('data-name');
                            const dataIndex = target.getAttribute('data-index');

                            Tracking.trackFilterAccordionHeaderExpanded(dataName, dataIndex);

                        },
                    }
                }
                {...restProps}
            >
                <Content>
                    <Filter
                        type={filterConfig.component}
                        fields={fields}
                        onChange={filterOnChangeHandler}
                        componentConfig={componentConfig}
                        filterName={filterConfig.filterName}
                    />
                </Content>
            </AccordionItem>
        </Container>
    );

};

export default React.memo(FilterWrapper, shouldNotReRender);
